module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/seat-pad-d671c00f2510c86090c69bd306f2560e.svg";